import { Button, ButtonProps } from '@ttoss/ui';
import { FC } from 'react';
import { Icon } from '@iconify/react';

type RoundButtonIconProps = ButtonProps & {
  icon?: string;
  size?: 'md' | 'lg';
};

const RoundButtonIcon: FC<RoundButtonIconProps> = ({
  icon,
  sx,
  children,
  size = 'lg',
  ...props
}) => {
  return (
    <Button
      sx={{
        width: size === 'lg' ? '55px' : '34px',
        height: size === 'lg' ? '55px' : '34px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: size === 'lg' ? 6 : null,
        borderRadius: '50%',
        fontSize: size === 'lg' ? 5 : 3,
        backgroundColor: 'background',
        color: '#000000',
        boxShadow: 1,
        cursor: 'pointer',
        transition: '0.2s',
        ':hover': {
          transform: 'scale(1.05)',
        },
        ...sx,
      }}
      {...props}
    >
      {icon ? <Icon icon={icon} /> : children}
    </Button>
  );
};

export default RoundButtonIcon;
